import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const UserRoleUrl = `${Base_Url}/ClientIndustry`;

export const GetClientIndustryList = async (params) => {
  const res = await postApiWithAuthorization(
    `${UserRoleUrl}/GetClientIndustryList`,
    params
  );
  return res;
};

export const AddUpdateClientIndustry = async (params) => {
  const res = await postApiWithAuthorization(
    `${UserRoleUrl}/AddUpdateClientIndustry?ModuleName=${params.ModuleName}`,
    params
  );
  return res;
};
export const GetClientIndustryModel = async (ModuleName, KeyID, AdminKeyID) => {
  const res = await getApiWithAuthorization(
    `${UserRoleUrl}/GetClientIndustryModel?ModuleName=${ModuleName}&AdminKeyID=${AdminKeyID}&ClientIndustryKeyID=${KeyID}`
  );
  return res;
};

export const ChangeClientIndustryStatus = async (
  ModuleName,
  KeyID,
  AdminKeyID
) => {
  const res = await getApiWithAuthorization(
    `${UserRoleUrl}/ChangeClientIndustryStatus?ModuleName=${ModuleName}&AdminKeyID=${AdminKeyID}&ClientIndustryKeyID=${KeyID}`
  );
  return res;
};

export const DeleteClientIndustry = async (ModuleName, KeyID, AdminKeyID) => {
  const res = await getApiWithAuthorization(
    `${UserRoleUrl}/DeleteClientIndustry?ModuleName=${ModuleName}&AdminKeyID=${AdminKeyID}&ClientIndustryKeyID=${KeyID}`
  );
  return res;
};
